export const SINGLE_LABEL_FLOW_AB_TEST = 'Single Label Flow Test';
export const EXPRESS_LABEL_AB_TEST_VARIANT = 'Single Label Express';
export const CHOSEN_NEW_EXP_TEST = 'Choose New Experience Test';
export const NEW_EXP_CHOSEN = 'New Experience Chosen';
export const OLD_EXP_CHOSEN = 'Old Experience Chosen';
export const ONBOARDING_STREAMLINED_TEST = 'Onboarding Streamlined Prompt Sender Address Test';
export const ONBOARDING_CONTROL = 'Onboarding Control';
export const ONBOARDING_VARIANT = 'Onboarding Streamlined';
export const ONE_DOLLAR_BILLING_THRESHOLD = 'One Dollar Billing Threshold';
export const ONE_DOLLAR_BILLING_THRESHOLD_ENABLED = 'One Dollar Billing Threshold Enabled';
